module.exports = __webpack_public_path__ + "static/media/m12cr93.33dd70ac.png";